import { type DotsMenuItem, getDotsMenuItems } from "@client/lib/menu";
import {
  createShallowEqualSelector,
  getCompositeSettingSelector,
  getLayoutSettingValueSelector,
  screenSelector,
  stateSelectors,
  TargetSelector
} from "@client/selectors";
import { type MenuItem } from "@client/types";
import { EMPTY_ARRAY } from "@common/lib/array";
import { createSelector } from "reselect";

export const onePageTypeSelector = getLayoutSettingValueSelector("type", "onePage");

const item1Selector = getCompositeSettingSelector<DotsMenuItem>(TargetSelector.Layout, "item1", "onePage");
const item2Selector = getCompositeSettingSelector<DotsMenuItem>(TargetSelector.Layout, "item2", "onePage");
const item3Selector = getCompositeSettingSelector<DotsMenuItem>(TargetSelector.Layout, "item3", "onePage");
const item4Selector = getCompositeSettingSelector<DotsMenuItem>(TargetSelector.Layout, "item4", "onePage");

const itemsSelector = createSelector(
  [item1Selector, item2Selector, item3Selector, item4Selector],
  (item1, item2, item3, item4) => [item1, item2, item3, item4].filter((x) => !!x)
);

const mainChildrenIdsSelector = createSelector(
  [stateSelectors.contentEntitiesSelector],
  (entities) => entities["main"]?.childrenIds ?? EMPTY_ARRAY
);

export const dotsMenuItemsSelector = createShallowEqualSelector(
  [itemsSelector, mainChildrenIdsSelector, stateSelectors.contentEntitiesSelector, screenSelector],
  (items, childrenIds, entities, screen): MenuItem[] => getDotsMenuItems(items, childrenIds, entities, screen)
);
